import load from "load-script";

const loadedUrls = {};

export default function loadScript(url) {
  if (loadedUrls[url]) {
    return loadedUrls[url];
  }

  loadedUrls[url] = new Promise((resolve, reject) => {
    load(url, (err, script) => {
      if (err) {
        reject(err);
      } else {
        resolve(script);
      }
    });
  });

  return loadedUrls[url];
}

// Drops the cached load so the next loadScript(url) injects the script again,
// for callers that remove a script's tag and globals to re-initialise it
export function forgetScript(url) {
  delete loadedUrls[url];
}
